/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Job_Deleted_SuccessInputs */

const en_scene_description_job_deleted_success = /** @type {(inputs: Scene_Description_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot description job deleted successfully.`)
};

const fr_scene_description_job_deleted_success = /** @type {(inputs: Scene_Description_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description du plan supprimée avec succès.`)
};

const de_scene_description_job_deleted_success = /** @type {(inputs: Scene_Description_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Auftrag für die Aufnahmebeschreibung wurde erfolgreich gelöscht.`)
};

const it_scene_description_job_deleted_success = /** @type {(inputs: Scene_Description_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione dell'inquadratura eliminata con successo.`)
};

const ru_scene_description_job_deleted_success = /** @type {(inputs: Scene_Description_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание задания успешно удалено.`)
};

const es_scene_description_job_deleted_success = /** @type {(inputs: Scene_Description_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La descripción de la toma se eliminó correctamente.`)
};

const zh_cn2_scene_description_job_deleted_success = /** @type {(inputs: Scene_Description_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`镜头描述任务已成功删除。`)
};

const ja_scene_description_job_deleted_success = /** @type {(inputs: Scene_Description_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撮影内容の説明は正常に削除されました。`)
};

const hi_scene_description_job_deleted_success = /** @type {(inputs: Scene_Description_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट विवरण कार्य सफलतापूर्वक हटा दिया गया।`)
};

const pt_pt2_scene_description_job_deleted_success = /** @type {(inputs: Scene_Description_Job_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição da foto excluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Shot description job deleted successfully." |
*
* @param {Scene_Description_Job_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_job_deleted_success = /** @type {((inputs?: Scene_Description_Job_Deleted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Job_Deleted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_description_job_deleted_success(inputs)
	if (locale === "de") return de_scene_description_job_deleted_success(inputs)
	if (locale === "it") return it_scene_description_job_deleted_success(inputs)
	if (locale === "ru") return ru_scene_description_job_deleted_success(inputs)
	if (locale === "es") return es_scene_description_job_deleted_success(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_description_job_deleted_success(inputs)
	if (locale === "ja") return ja_scene_description_job_deleted_success(inputs)
	if (locale === "hi") return hi_scene_description_job_deleted_success(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_description_job_deleted_success(inputs)
	return en_scene_description_job_deleted_success(inputs)
});